import angular from 'angular';
import documentSharing from './documentSharing';
import './style.scss';

export default angular
  .module('components.documentSharing', [])
  .component('documentSharing', documentSharing).name;
